<button
  mat-raised-button
  (click)="generateWord()"
  [disabled]="generating"
  >
  <div class="row">
    <div class="numberContainer">
      @if (number) {
        <h2>{{number}}</h2>
      }
    </div>
    <div class="circle">
      @if (generating) {
        <mat-spinner diameter="20"></mat-spinner>
      }
      @else {
        <mat-icon
          class="circle-icon"
          aria-hidden="false"
          aria-label="Download word rapport"
          fontIcon="download"
        ></mat-icon>
      }
    </div>
    <div class="tileContainer"></div>
  </div>
  <p>Download Word rapportage</p>
</button>
<!-- Image in spiderweb used when downloading the rapport-->
@if(generating) {
  <app-spiderweb (chartReady)="onChartReady($event)"></app-spiderweb>
}



